<template>
    <vue-table-card title="Contact Us Page" :show-search-box="false" :fields="fields" :url="listUrl" :per-page="10" ref="table">
        <template #buttons>
            <btn color="success" icon="fa fa-plus" size="sm" @click="$refs.addModal.show()" text="Add"/>
        </template>
        <template #image="{rowData}">
            <div class="container-image" @click="viewFile(rowData.image)">
                <img :src="rowData.image" alt="Avatar" class="c-image">
                <div class="c-overlay">
                    <div class="c-icon">
                        <i class="fa fa-eye"></i>
                    </div>
                </div>
            </div>
        </template>
        <template #is_enabled="{rowData}">
            <p v-if="rowData.is_enabled">Yes</p>
            <p v-else>No</p>
        </template>

        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <btn size="xs" text="View" @click="viewDetails(rowData.id)"/>
                <delete-btn @click="setDelete(rowData)"/>
            </div>
        </template>

        <template #footer>
            <modal title="Add Item" ref="addModal" width="40r" header-color="primary" no-close-on-backdrop>
                <add-contact-us-item @success="formSuccess"/>
            </modal>

            <modal title="Edit Item" ref="editModal" width="40r" header-color="primary" no-close-on-backdrop>
                <edit-contact-us-item :initial-data="editingItem" @success="formSuccess"/>
            </modal>

            <delete-modal ref="deleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
                <p>You are about to delete the item <b v-html="deletingItem && deletingItem.name"></b>. Are you sure ?
                </p>

                <template #loading>
                    <loading-animation/>
                    Please wait while we delete <b v-html="deletingItem && deletingItem.name"></b>.
                </template>
            </delete-modal>
        </template>

    </vue-table-card>
</template>

<script>
import urls from '../../../../data/urls';
import AddContactUsItem from './AddContactUsItem';
import EditContactUsItem from './EditContactUsItem';

export default {
    name: 'ContactUsPageListing',
    components: { EditContactUsItem, AddContactUsItem },
    data () {
        return {
            listUrl: urls.admin.contactUsPage.list,
            addUrl: urls.admin.contactUsPage.addEdit,
            deleteUrl: urls.admin.contactUsPage.delete,
            editingItem: null,
            deletingItem: null,
            fields: [
                {
                    name: 'order',
                    sortField: 'order',
                    title: 'Order'
                },
                {
                    name: 'heading',
                    sortField: 'heading',
                    title: 'Heading'
                },
                {
                    name: 'created_at',
                    sortField: 'created_at',
                    title: 'Created At'
                },
                {
                    name: '__slot:is_enabled',
                    title: 'Enabled'
                },
                {
                    name: '__slot:actions',
                    titleClass: 'center aligned text-right',
                    dataClass: 'aligned text-right'
                }
            ]
        };
    },
    methods: {
        viewFile (file) {
            window.open(file);
        },
        viewDetails (id) {
            this.$router.push('/admin/contact-us-page/' + id + '/details/');
        },
        formSuccess () {
            const refs = this.$refs;
            refs.addModal.close();
            refs.editModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.$refs.editModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.deleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$refs.deleteModal.close();
            this.$notify('Deleted Successfully', 'Success', {
                type: 'success'
            });
            this.$refs.table.refreshTable();
        }
    }
};
</script>
